<template>
  <el-container>
    <el-main>
      <el-card>
        <div slot="header" class="clearfix">
          <span class="card-header">{{data.judul}}</span>
          <span style="float: right; padding: 3px 0">{{stringWaktu}}</span>
          
        </div>
        <p v-if="dataSoal.length" style="text-indent: -20px; padding-left: 20px; text-align: justify;">{{dataSoal[nomorSoal-1]['pertanyaan']}}</p>
        <div v-if="dataSoal.length" class="jawaban">
          <div v-for="(i,k) in dataSoal[nomorSoal-1].jawaban" :key="k">
            <el-radio style="white-space: normal; text-indent: -12px; margin-left: 30px; margin-top: 10px;" v-model="jawaban[nomorSoal-1]" :label="i.id">{{i.data}}</el-radio>
          </div>

        </div>
        <el-pagination
          style="margin-top:20px"
          background
          layout="prev, pager, next"
          :total="dataSoal.length"
          :current-page.sync="nomorSoal"
          :page-size="1"
          :pager-count="5">
        </el-pagination>
        <el-button @click="buttonSelesaiMengerjakan" style="margin-top: 20px; float: right; margin-bottom: 20px">Selesai Mengerjakan</el-button>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import { database } from '../firebase'

export default {
  data() {
    return {
      radio: null,
      data: {},
      dataSoal: [],
      nomorSoal: 1,
      jawaban: [],
      waktuMulai: this.$store.state.waktuMulai,
      now: new Date(),
      waktuDetik: 99,
      stringWaktu: '00:00',
      timer: null
    }
  },
  watch: {
    jawaban() {
      this.$store.commit('updateJawaban', this.jawaban)
    },

  },
  computed: {
    
  },
  mounted() {
    this.sisaWaktu()
    this.updateWaktu()

    this.jawaban = localStorage.jawaban

    
    if (this.jawaban == null || this.jawaban == 'null' || this.jawaban == '' || this.jawaban == 'undefined') {
      this.jawaban = [] 
    } else {
      this.jawaban = this.jawaban.split(',')
    }

    var soalRef = database.ref('isi/'+this.$route.params.halaman)
    soalRef.on('value', (snapshot) => {
      this.data = snapshot.val()
      this.dataSoal = []
      for(var i in this.data.data) {
        this.dataSoal.push({
          id: i,
          pertanyaan: this.data.data[i]['pertanyaan'],
          jawaban: [
            {id: 'jawaban1', data: this.data.data[i]['jawaban1']},
            {id: 'jawaban2', data: this.data.data[i]['jawaban2']},
            {id: 'jawaban3', data: this.data.data[i]['jawaban3']},
            {id: 'jawaban4', data: this.data.data[i]['jawaban4']},
            {id: 'jawaban5', data: this.data.data[i]['jawaban5']},
          ],
          jawaban_benar: this.data.data[i]['jawaban_benar'],
        })
      }
    })
  },
  methods: {
    buttonSelesaiMengerjakan: function () {
      this.$confirm('Apakan anda yakin sudah selesai?', 'Peringantan', {
        confirmButtonText: 'Selsai',
        cancelButtonText: 'Batal',
        type: 'warning'
      }).then(() => {
        this.selesaiMengerjakan()
      })
    },
    selesaiMengerjakan: function() {
      
      var jumlah_benar = 0
      for (var i in this.dataSoal) {
        if (this.jawaban[i] == this.dataSoal[i].jawaban_benar) {
          jumlah_benar ++
        }
      }

      var update = {}
      update['pengguna/'+this.$store.state.user.uid+'/evaluasi/'+this.$route.params.halaman+'/jawaban'] = localStorage.jawaban
      update['pengguna/'+this.$store.state.user.uid+'/evaluasi/'+this.$route.params.halaman+'/jumlah_benar'] = jumlah_benar
      update['pengguna/'+this.$store.state.user.uid+'/evaluasi/'+this.$route.params.halaman+'/jumlah_soal'] = this.dataSoal.length
      
      database.ref().update(update).then(()=>{
        this.$store.commit('updateJawaban', null)
        this.$store.commit('setLagiNgerjain', {lagiNgerjain: false, lagiNgerjainHalaman: null})
        this.$router.push({name: this.$route.params.halaman})
        clearTimeout(this.timer)
      }).catch((error) => {
        this.$notify.error({
          title: 'Error',
          message: error
        });
      })      
    },
    updateWaktu: function() {
      this.timer = setTimeout(() => {
        this.now = new Date()
        this.sisaWaktu()

        if (this.waktuDetik < 1) {
          this.selesaiMengerjakan()
        } else {
          this.updateWaktu()
        }        
      }, 1000)
    },
    sisaWaktu: function () {
      this.waktuDetik = (this.data.waktu_pengerjaan*60) -  Math.ceil((this.now - new Date(this.waktuMulai))/1000)
      this.stringWaktu = Math.floor(this.waktuDetik/60) + ':' + (this.waktuDetik%60 < 10 ? '0': '') + this.waktuDetik%60
    }
  }
}
</script>